import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import type { Thread } from "app/pages/sales-intelligence/modules/ai-agent/types/thread";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useGetThreads = (): UseQueryResult<Thread[]> => {
    return useQuery({
        queryKey: aiAgentQueryKeys.threads(),
        queryFn: ({ signal }) => {
            return salesApiService.aiAgent.meeting.getThreads({ cancellation: signal });
        },
    });
};
